<template>
  <div class="third-party-wrapper">
    <div class="third-party">
      <template v-if="!loading">
        <button
          v-for="(vendor, idx) in thirdParty"
          :key="idx"
          :class="['button', 'third-party-button', vendor]"
          @click.prevent="login(vendor)"
        >
          <img
            :src="`/assets/img/${vendor === 'facebook' ? vendor + '-white' : vendor}.svg`"
            :alt="vendor"
            height="18"
            width="18"
          />
          <span>{{ vendor.charAt(0).toUpperCase() + vendor.slice(1) }}</span>
        </button>
      </template>
      <loader-spin v-else />
    </div>
    <div class="separator">
      <span>Or</span>
    </div>
  </div>
</template>

<script>
import Axios from 'axios';
import Auth from '@/shared/auth';
import LoaderSpin from '@/shared/UIComponents/LoaderSpin';
const Config = require('~/config/default.env').default;

export default {
  name: 'login-third-party',
  components: {
    LoaderSpin,
  },
  data() {
    return {
      thirdParty: ['facebook'],
      loading: false,
    };
  },
  mounted() {
    this.fetchGoogleOptions();
  },
  methods: {
    async login(vendor) {
      if (vendor === 'facebook') {
        try {
          const accessToken = await FB.getAccessToken();
          if (accessToken) {
            this.loading = true;
            this.callback(accessToken, vendor);
          } else {
            FB.login(
              function (response) {
                if (response.status === 'connected') {
                  this.loading = true;
                  this.callback(response.authResponse.accessToken, vendor);
                }
              }.bind(this),
              { scope: 'email' }
            );
          }
        } catch (error) {
          console.log(error);
          this.$toasted.global.error('Failed. Please try again later.');
        }
      } else if (vendor === 'google') {
        try {
          const tokenClient = google.accounts.oauth2.initTokenClient({
            client_id: Config.GOOGLE_CLIENT_ID,
            scope: 'profile email',
            prompt: 'select_account',
            callback: (response) => this.callback(response.access_token, vendor),
          });
          tokenClient.requestAccessToken();
        } catch (error) {
          this.$toasted.global.error(error);
        }
      }
    },
    async callback(token, name) {
      await Auth.login(this, { name, token });
      this.loading = false;
    },
    fetchGoogleOptions() {
      return Axios.get(Config.MS_SOCO_PUBLIC_API_URL + '/third-party-login')
        .then((response) => {
          if (response.status == 200 && response.data && response.data.success === true) {
            const datas = response.data.data;
            const googleLoginStatus = datas.filter((datas) => datas.platform == 'Review Web');
            if (googleLoginStatus.length > 0 && googleLoginStatus[0].is_active) {
              this.thirdParty.push('google');
            }
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.third-party-wrapper {
  width: 100%;
  .third-party {
    display: flex;
    gap: 12px;
    flex-direction: row-reverse;
    .third-party-button {
      flex: 1 1;
      padding: 12px;
      font-family: 'lato-regular', sans-serif;
      font-size: 14px;
      letter-spacing: 0.22px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      text-transform: none;
      border: none;
      > img {
        margin-right: 10px;
      }
      &.facebook {
        background-color: #1878f3;
        color: #ffffff;
        > img {
          height: 25px;
          width: 25px;
        }
      }
      &.google {
        background-color: #ffffff;
        color: #231f20;
        border: 1.5px solid #e5e5e5;
        &:hover {
          color: #231f20 !important;
        }
      }
    }
    .loaderspinwrap {
      /deep/ .loaderspin {
        margin: auto;
      }
    }
  }
}
.separator {
  margin: 18px 0;
  width: 100%;
  position: relative;
  height: 1px;
  background-color: #8c8582;
  span {
    position: absolute;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: white;
    width: 72px;
    top: -50%;
    font-family: 'Lato', sans-serif;
    font-size: 13px;
    color: #231f20;
    text-align: center;
    line-height: 13px;
  }
}
</style>
